import { render, staticRenderFns } from "./KeyboardCompletoBottom.vue?vue&type=template&id=037af8de"
import script from "./KeyboardCompletoBottom.vue?vue&type=script&lang=js"
export * from "./KeyboardCompletoBottom.vue?vue&type=script&lang=js"
import style0 from "./KeyboardCompletoBottom.vue?vue&type=style&index=0&id=037af8de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports